// JOLYN Size Chart Data
// Contains all sizing information in both inches and centimeters
// Based on official size charts and CSV data

window.JolynSizeChartData = {
  // Women's Training One Pieces
  womenOnePiecesTraining: {
    in: [
      {
        size: "18",
        category: "YOUTH",
        dressSize: "Youth 5/6",
        torso: "40-43",
        cupSize: "",
        waist: "19-21",
        hip: "22-25",
        overBust: "22-23",
      },
      {
        size: "20",
        category: "YOUTH",
        dressSize: "Youth 7/8",
        torso: "44-47",
        cupSize: "",
        waist: "22-24",
        hip: "26-29",
        overBust: "24-26",
      },
      {
        size: "22 / 22J",
        category: "YOUTH",
        dressSize: "Youth 10",
        torso: "48-51",
        cupSize: "",
        waist: "23-24",
        hip: "30-32",
        overBust: "27-28",
      },
      {
        size: "24J",
        category: "YOUTH",
        dressSize: "Youth 12",
        torso: "53",
        cupSize: "",
        waist: "24-25",
        hip: "33-34",
        overBust: "29-30",
      },
      {
        size: "24",
        category: "ADULT",
        dressSize: "00",
        torso: "56",
        cupSize: "AA",
        waist: "23-24",
        hip: "33-34",
        overBust: "29-30",
      },
      {
        size: "26",
        category: "ADULT",
        dressSize: "0 | 2",
        torso: "57",
        cupSize: "A",
        waist: "25-26",
        hip: "35-36",
        overBust: "31-32",
      },
      {
        size: "28",
        category: "ADULT",
        dressSize: "2 | 4",
        torso: "58.5",
        cupSize: "B",
        waist: "27-28",
        hip: "37-38",
        overBust: "33-34",
      },
      {
        size: "30",
        category: "ADULT",
        dressSize: "4 | 6",
        torso: "60",
        cupSize: "C",
        waist: "29-30",
        hip: "39-40",
        overBust: "35-36",
      },
      {
        size: "32",
        category: "ADULT",
        dressSize: "6 | 8",
        torso: "61.5",
        cupSize: "C",
        waist: "31-32",
        hip: "41-42",
        overBust: "37-38",
      },
      {
        size: "34",
        category: "ADULT",
        dressSize: "8 | 10",
        torso: "63",
        cupSize: "C | D",
        waist: "33-34",
        hip: "43-44",
        overBust: "39-40",
      },
      {
        size: "36",
        category: "ADULT",
        dressSize: "10 | 12",
        torso: "64.5",
        cupSize: "",
        waist: "35-36",
        hip: "45-46",
        overBust: "41-42",
      },
      {
        size: "38",
        category: "ADULT",
        dressSize: "12 | 14",
        torso: "66",
        cupSize: "",
        waist: "37-38",
        hip: "47-48",
        overBust: "43-44",
      },
      {
        size: "40",
        category: "ADULT",
        dressSize: "14 | 16",
        torso: "67.5",
        cupSize: "",
        waist: "39-40",
        hip: "49-50",
        overBust: "45-46",
      },
      {
        size: "42",
        category: "ADULT",
        dressSize: "18 | 20",
        torso: "69",
        cupSize: "",
        waist: "41-42",
        hip: "51-52",
        overBust: "47-48",
      },
      {
        size: "44",
        category: "ADULT",
        dressSize: "20 | 22",
        torso: "70.5",
        cupSize: "",
        waist: "43-44",
        hip: "53-54",
        overBust: "49-50",
      },
    ],
    cm: [
      {
        size: "18",
        category: "YOUTH",
        dressSize: "5–6 Years",
        torso: "102–109",
        cupSize: "",
        waist: "48–53",
        hip: "56–64",
        overBust: "56–58",
      },
      {
        size: "20",
        category: "YOUTH",
        dressSize: "7–8 Years",
        torso: "112–119",
        cupSize: "",
        waist: "56–61",
        hip: "66–74",
        overBust: "61–66",
      },
      {
        size: "22 / 22J",
        category: "YOUTH",
        dressSize: "9–10 Years",
        torso: "122–130",
        cupSize: "",
        waist: "58–61",
        hip: "76–81",
        overBust: "69–71",
      },
      {
        size: "24J",
        category: "YOUTH",
        dressSize: "11–12 Years",
        torso: "135",
        cupSize: "",
        waist: "61–64",
        hip: "84–86",
        overBust: "74–76",
      },
      {
        size: "24",
        category: "ADULT",
        dressSize: "4",
        torso: "142",
        cupSize: "AA",
        waist: "58–61",
        hip: "84–86",
        overBust: "74–76",
      },
      {
        size: "26",
        category: "ADULT",
        dressSize: "4 | 6",
        torso: "145",
        cupSize: "A",
        waist: "64–66",
        hip: "89–91",
        overBust: "79–81",
      },
      {
        size: "28",
        category: "ADULT",
        dressSize: "6 | 8",
        torso: "149",
        cupSize: "B",
        waist: "69–71",
        hip: "94–97",
        overBust: "84–86",
      },
      {
        size: "30",
        category: "ADULT",
        dressSize: "8 | 10",
        torso: "152",
        cupSize: "C",
        waist: "74–76",
        hip: "99–102",
        overBust: "89–91",
      },
      {
        size: "32",
        category: "ADULT",
        dressSize: "10 | 12",
        torso: "156",
        cupSize: "C",
        waist: "79–81",
        hip: "104–107",
        overBust: "94–97",
      },
      {
        size: "34",
        category: "ADULT",
        dressSize: "12 | 14",
        torso: "160",
        cupSize: "C | D",
        waist: "84–86",
        hip: "109–112",
        overBust: "99–102",
      },
      {
        size: "36",
        category: "ADULT",
        dressSize: "14 | 16",
        torso: "164",
        cupSize: "",
        waist: "89–91",
        hip: "114–117",
        overBust: "104–107",
      },
      {
        size: "38",
        category: "ADULT",
        dressSize: "16 | 18",
        torso: "168",
        cupSize: "",
        waist: "94–97",
        hip: "119–122",
        overBust: "109–112",
      },
      {
        size: "40",
        category: "ADULT",
        dressSize: "18 | 20",
        torso: "172",
        cupSize: "",
        waist: "99–102",
        hip: "125–127",
        overBust: "114–117",
      },
      {
        size: "42",
        category: "ADULT",
        dressSize: "22 | 24",
        torso: "175",
        cupSize: "",
        waist: "104–107",
        hip: "130–132",
        overBust: "119–122",
      },
      {
        size: "44",
        category: "ADULT",
        dressSize: "24 | 26",
        torso: "179",
        cupSize: "",
        waist: "109–112",
        hip: "135–137",
        overBust: "125–127",
      },
    ],
  },

  // Caroline One Pieces (different dress sizing)
  womenOnePiecesCaroline: {
    in: [
      {
        size: "26",
        dressSize: "0",
        torso: "57",
        cupSize: "A",
        waist: "25-26",
        hip: "35-36",
        overBust: "31-32",
      },
      {
        size: "28",
        dressSize: "2",
        torso: "58.5",
        cupSize: "B",
        waist: "27-28",
        hip: "37-38",
        overBust: "33-34",
      },
      {
        size: "30",
        dressSize: "4",
        torso: "60",
        cupSize: "C",
        waist: "29-30",
        hip: "39-40",
        overBust: "35-36",
      },
      {
        size: "32",
        dressSize: "6",
        torso: "61.5",
        cupSize: "C",
        waist: "31-32",
        hip: "41-42",
        overBust: "37-38",
      },
      {
        size: "34",
        dressSize: "8",
        torso: "63",
        cupSize: "C | D",
        waist: "33-34",
        hip: "43-44",
        overBust: "39-40",
      },
      {
        size: "36",
        dressSize: "10",
        torso: "64.5",
        cupSize: "",
        waist: "35-36",
        hip: "45-46",
        overBust: "41-42",
      },
      {
        size: "38",
        dressSize: "12",
        torso: "66",
        cupSize: "",
        waist: "37-38",
        hip: "47-48",
        overBust: "43-44",
      },
      {
        size: "40",
        dressSize: "14",
        torso: "67.5",
        cupSize: "",
        waist: "39-40",
        hip: "49-50",
        overBust: "45-46",
      },
      {
        size: "42",
        dressSize: "18 | 20",
        torso: "69",
        cupSize: "",
        waist: "41-42",
        hip: "51-52",
        overBust: "47-48",
      },
      {
        size: "44",
        dressSize: "20 | 22",
        torso: "70.5",
        cupSize: "",
        waist: "43-44",
        hip: "53-54",
        overBust: "49-50",
      },
    ],
    cm: [
      {
        size: "26",
        dressSize: "4",
        torso: "145",
        cupSize: "A",
        waist: "64–66",
        hip: "89–92",
        overBust: "79–81",
      },
      {
        size: "28",
        dressSize: "6",
        torso: "149",
        cupSize: "B",
        waist: "69–71",
        hip: "94–97",
        overBust: "84–86",
      },
      {
        size: "30",
        dressSize: "8",
        torso: "153",
        cupSize: "C",
        waist: "74–76",
        hip: "99–102",
        overBust: "89–92",
      },
      {
        size: "32",
        dressSize: "10",
        torso: "156",
        cupSize: "C",
        waist: "79–81",
        hip: "104–107",
        overBust: "94–97",
      },
      {
        size: "34",
        dressSize: "12",
        torso: "160",
        cupSize: "C | D",
        waist: "84–86",
        hip: "109–112",
        overBust: "99–102",
      },
      {
        size: "36",
        dressSize: "14",
        torso: "164",
        cupSize: "",
        waist: "89–92",
        hip: "114–117",
        overBust: "104–107",
      },
      {
        size: "38",
        dressSize: "16",
        torso: "168",
        cupSize: "",
        waist: "94–97",
        hip: "119–122",
        overBust: "109–112",
      },
      {
        size: "40",
        dressSize: "18",
        torso: "172",
        cupSize: "",
        waist: "99–102",
        hip: "125–127",
        overBust: "115–117",
      },
      {
        size: "42",
        dressSize: "22 | 24",
        torso: "175",
        cupSize: "",
        waist: "104–107",
        hip: "130–132",
        overBust: "119–122",
      },
      {
        size: "44",
        dressSize: "24 | 26",
        torso: "179",
        cupSize: "",
        waist: "109–112",
        hip: "135–137",
        overBust: "125–127",
      },
    ],
  },

  // Women's Surf One Pieces
  womenOnePiecesSurf: {
    in: [
      {
        size: "XS",
        dressSize: "2 | 4",
        bust: "31-32",
        cup: "A",
        waist: "25-26",
        hip: "35-36",
        torso: "58-59",
      },
      {
        size: "S",
        dressSize: "4 | 6",
        bust: "33-34",
        cup: "A/B",
        waist: "27-28",
        hip: "37-38",
        torso: "60-61",
      },
      {
        size: "M",
        dressSize: "6 | 8",
        bust: "35-36",
        cup: "B/C",
        waist: "29-30",
        hip: "39-40",
        torso: "62-63",
      },
      {
        size: "L",
        dressSize: "8 | 10",
        bust: "37-38",
        cup: "C",
        waist: "31-33",
        hip: "41-42",
        torso: "64-65",
      },
      {
        size: "XL",
        dressSize: "10 | 12",
        bust: "39-40",
        cup: "C/D",
        waist: "34-35",
        hip: "43-45",
        torso: "66-67",
      },
      {
        size: "1X",
        dressSize: "14 | 16",
        bust: "42-45",
        cup: "D/DD",
        waist: "37-40",
        hip: "47-50",
        torso: "69-71",
      },
      {
        size: "2X",
        dressSize: "16 | 18",
        bust: "46-48",
        cup: "D/DD",
        waist: "41-43",
        hip: "51-53",
        torso: "71-74",
      },
      {
        size: "3X",
        dressSize: "20 | 22",
        bust: "49-51",
        cup: "DD/E",
        waist: "44-46",
        hip: "54-56",
        torso: "75-77",
      },
      {
        size: "4X",
        dressSize: "24 | 26",
        bust: "52-54",
        cup: "DD/E",
        waist: "47-49",
        hip: "57-61",
        torso: "78-80",
      },
    ],
    cm: [
      {
        size: "XS",
        dressSize: "6 | 8",
        bust: "79–81",
        cup: "A",
        waist: "64–66",
        hip: "89–91",
        torso: "147–150",
      },
      {
        size: "S",
        dressSize: "8 | 10",
        bust: "84–86",
        cup: "A/B",
        waist: "69–71",
        hip: "94–97",
        torso: "152–155",
      },
      {
        size: "M",
        dressSize: "10 | 12",
        bust: "89–91",
        cup: "B/C",
        waist: "74–76",
        hip: "99–102",
        torso: "158–160",
      },
      {
        size: "L",
        dressSize: "12 | 14",
        bust: "94–97",
        cup: "C",
        waist: "79–84",
        hip: "104–107",
        torso: "163–165",
      },
      {
        size: "XL",
        dressSize: "14 | 16",
        bust: "99–102",
        cup: "C/D",
        waist: "86–89",
        hip: "109–114",
        torso: "168–170",
      },
      {
        size: "1X",
        dressSize: "18 | 20",
        bust: "107–114",
        cup: "D/DD",
        waist: "94–102",
        hip: "119–127",
        torso: "175–180",
      },
      {
        size: "2X",
        dressSize: "20 | 22",
        bust: "117–122",
        cup: "D/DD",
        waist: "104–109",
        hip: "130–135",
        torso: "180–188",
      },
      {
        size: "3X",
        dressSize: "24 | 26",
        bust: "125–130",
        cup: "DD/E",
        waist: "112–117",
        hip: "137–142",
        torso: "191–196",
      },
      {
        size: "4X",
        dressSize: "28 | 30",
        bust: "132–137",
        cup: "DD/E",
        waist: "119–125",
        hip: "145–155",
        torso: "198–203",
      },
    ],
  },

  // Women's Training Bikini Tops
  womenBikiniTopsTraining: {
    in: [
      {
        size: "XXS",
        overBust: "27–29",
        underBust: "26–27",
        cupSize: "AA",
        waist: "23–24",
      },
      {
        size: "XS",
        overBust: "31–32",
        underBust: "28–29",
        cupSize: "A",
        waist: "25–26",
      },
      {
        size: "S",
        overBust: "33–34",
        underBust: "30–31",
        cupSize: "A",
        waist: "27–28",
      },
      {
        size: "M",
        overBust: "35–36",
        underBust: "32–33",
        cupSize: "B",
        waist: "29–30",
      },
      {
        size: "L",
        overBust: "37–38",
        underBust: "34–35",
        cupSize: "C",
        waist: "31–32",
      },
      {
        size: "XL",
        overBust: "39–40",
        underBust: "36–37",
        cupSize: "C/D",
        waist: "33–34",
      },
      {
        size: "2XL/D",
        overBust: "38–39",
        underBust: "35–36",
        cupSize: "D/DD",
        waist: "35–36",
      },
      {
        size: "4XL/DD",
        overBust: "38–39",
        underBust: "35–36",
        cupSize: "DDD",
        waist: "37–38",
      },
    ],
    cm: [
      {
        size: "XXS",
        overBust: "69–74",
        underBust: "66–69",
        cupSize: "AA",
        waist: "59–61",
      },
      {
        size: "XS",
        overBust: "79–81",
        underBust: "71–74",
        cupSize: "A",
        waist: "64–66",
      },
      {
        size: "S",
        overBust: "84–86",
        underBust: "76–79",
        cupSize: "A",
        waist: "69–71",
      },
      {
        size: "M",
        overBust: "89–92",
        underBust: "81–84",
        cupSize: "B",
        waist: "74–76",
      },
      {
        size: "L",
        overBust: "94–97",
        underBust: "86–89",
        cupSize: "C",
        waist: "79–81",
      },
      {
        size: "XL",
        overBust: "99–102",
        underBust: "92–94",
        cupSize: "C/D",
        waist: "84–86",
      },
      {
        size: "2XL/D",
        overBust: "97–99",
        underBust: "89–92",
        cupSize: "D/DD",
        waist: "89–92",
      },
      {
        size: "4XL/DD",
        overBust: "97–99",
        underBust: "89–92",
        cupSize: "DDD",
        waist: "94–97",
      },
    ],
  },

  // Women's Surf Bikini Tops
  womenBikiniTopsSurf: {
    in: [
      {
        size: "XS",
        dressSize: "2 | 4",
        bust: "31-32",
        cupSize: "A",
        underBust: "27-28",
        waist: "25-26",
      },
      {
        size: "S",
        dressSize: "4 | 6",
        bust: "33-34",
        cupSize: "A/B",
        underBust: "29-30",
        waist: "27-28",
      },
      {
        size: "M",
        dressSize: "6 | 8",
        bust: "35-36",
        cupSize: "B/C",
        underBust: "31-32",
        waist: "29-30",
      },
      {
        size: "L",
        dressSize: "8 | 10",
        bust: "37-38",
        cupSize: "C",
        underBust: "33-34",
        waist: "31-33",
      },
      {
        size: "XL",
        dressSize: "10 | 12",
        bust: "39-40",
        cupSize: "C/D",
        underBust: "35-37",
        waist: "34-35",
      },
      {
        size: "1X",
        dressSize: "14 | 16",
        bust: "42-45",
        cupSize: "D/DD",
        underBust: "39-41",
        waist: "37-40",
      },
      {
        size: "2X",
        dressSize: "16 | 18",
        bust: "46-48",
        cupSize: "D/DD",
        underBust: "42-43",
        waist: "41-43",
      },
      {
        size: "3X",
        dressSize: "20 | 22",
        bust: "49-51",
        cupSize: "DD/E",
        underBust: "46-48",
        waist: "44-46",
      },
      {
        size: "4X",
        dressSize: "24 | 26",
        bust: "52-54",
        cupSize: "DD/E",
        underBust: "49-51",
        waist: "47-49",
      },
    ],
    cm: [
      {
        size: "XS",
        dressSize: "6 | 8",
        bust: "79–81",
        cupSize: "A",
        underBust: "69–71",
        waist: "64–66",
      },
      {
        size: "S",
        dressSize: "8 | 10",
        bust: "84–86",
        cupSize: "A/B",
        underBust: "74–76",
        waist: "69–71",
      },
      {
        size: "M",
        dressSize: "10 | 12",
        bust: "89–91",
        cupSize: "B/C",
        underBust: "79–81",
        waist: "74–76",
      },
      {
        size: "L",
        dressSize: "12 | 14",
        bust: "94–97",
        cupSize: "C",
        underBust: "84–86",
        waist: "79–84",
      },
      {
        size: "XL",
        dressSize: "14 | 16",
        bust: "99–102",
        cupSize: "C/D",
        underBust: "89–94",
        waist: "86–89",
      },
      {
        size: "1X",
        dressSize: "18 | 20",
        bust: "107–114",
        cupSize: "D/DD",
        underBust: "99–104",
        waist: "94–102",
      },
      {
        size: "2X",
        dressSize: "20 | 22",
        bust: "117–122",
        cupSize: "D/DD",
        underBust: "107–109",
        waist: "104–109",
      },
      {
        size: "3X",
        dressSize: "24 | 26",
        bust: "124–130",
        cupSize: "DD/E",
        underBust: "117–122",
        waist: "112–117",
      },
      {
        size: "4X",
        dressSize: "28 | 30",
        bust: "132–137",
        cupSize: "DD/E",
        underBust: "124–130",
        waist: "119–125",
      },
    ],
  },

  // Women's Training Bikini Bottoms
  womenBikiniBottomsTraining: {
    in: [
      { size: "XXS", waist: "23–24", hip: "30–32" },
      { size: "XS", waist: "25–26", hip: "35–36" },
      { size: "S", waist: "27–28", hip: "37–38" },
      { size: "M", waist: "29–30", hip: "39–40" },
      { size: "L", waist: "31–32", hip: "41–42" },
      { size: "XL", waist: "33–34", hip: "43–44" },
    ],
    cm: [
      { size: "XXS", waist: "59–61", hip: "76–82" },
      { size: "XS", waist: "64–66", hip: "89–92" },
      { size: "S", waist: "69–71", hip: "94–97" },
      { size: "M", waist: "74–76", hip: "99–102" },
      { size: "L", waist: "79–81", hip: "104–107" },
      { size: "XL", waist: "84–86", hip: "109–112" },
    ],
  },

  // Women's Surf Bikini Bottoms
  womenBikiniBottomsSurf: {
    in: [
      { size: "XS", dressSize: "2 | 4", waist: "25-26", hip: "35-36" },
      { size: "S", dressSize: "4 | 6", waist: "27-28", hip: "37-38" },
      { size: "M", dressSize: "6 | 8", waist: "29-30", hip: "39-40" },
      { size: "L", dressSize: "8 | 10", waist: "31-33", hip: "41-42" },
      { size: "XL", dressSize: "10 | 12", waist: "34-35", hip: "43-45" },
      { size: "1X", dressSize: "14 | 16", waist: "37-40", hip: "47-50" },
      { size: "2X", dressSize: "16 | 18", waist: "41-43", hip: "51-53" },
      { size: "3X", dressSize: "20 | 22", waist: "44-46", hip: "54-56" },
      { size: "4X", dressSize: "24 | 26", waist: "47-49", hip: "57-61" },
    ],
    cm: [
      { size: "XS", dressSize: "6 | 8", waist: "64–66", hip: "89–91" },
      { size: "S", dressSize: "8 | 10", waist: "69–71", hip: "94–97" },
      { size: "M", dressSize: "10 | 12", waist: "74–76", hip: "99–102" },
      { size: "L", dressSize: "12 | 14", waist: "79–84", hip: "104–107" },
      { size: "XL", dressSize: "14 | 16", waist: "86–89", hip: "109–114" },
      { size: "1X", dressSize: "18 | 20", waist: "94–102", hip: "119–127" },
      { size: "2X", dressSize: "20 | 22", waist: "104–109", hip: "130–135" },
      { size: "3X", dressSize: "24 | 26", waist: "112–117", hip: "137–142" },
      { size: "4X", dressSize: "28 | 30", waist: "119–124", hip: "145–155" },
    ],
  },

  // Men's Swim Briefs
  mensSwimBriefs: {
    in: [
      { size: "22", waist: "20–22", hip: "23–24" },
      { size: "24", waist: "23–25", hip: "25–27" },
      { size: "26", waist: "25–28", hip: "27–31" },
      { size: "28", waist: "28–30", hip: "32–33" },
      { size: "30", waist: "30–32", hip: "34–35" },
      { size: "32", waist: "32–34", hip: "36–37" },
      { size: "34", waist: "34–36", hip: "38–39" },
      { size: "36", waist: "36–38", hip: "40–41" },
      { size: "38", waist: "38–40", hip: "42–43" },
    ],
    cm: [
      { size: "22", waist: "51–56", hip: "59–61" },
      { size: "24", waist: "59–64", hip: "64–69" },
      { size: "26", waist: "64–71", hip: "69–79" },
      { size: "28", waist: "71–76", hip: "81–84" },
      { size: "30", waist: "76–81", hip: "86–89" },
      { size: "32", waist: "81–86", hip: "92–94" },
      { size: "34", waist: "86–92", hip: "97–99" },
      { size: "36", waist: "92–97", hip: "102–104" },
      { size: "38", waist: "97–102", hip: "106–109" },
    ],
  },

  // Men's Swim Jammer
  mensSwimJammer: {
    in: [
      {
        size: "22",
        waist: "20–22",
        hip: "23–24",
        thigh: "13–14",
        inseam: "5.75",
      },
      {
        size: "24",
        waist: "23–25",
        hip: "25–27",
        thigh: "15–17",
        inseam: "6.25",
      },
      {
        size: "26",
        waist: "25–28",
        hip: "27–31",
        thigh: "16–17",
        inseam: "7.25",
      },
      { size: "28", waist: "28–30", hip: "32–33", thigh: "18–19", inseam: "8" },
      {
        size: "30",
        waist: "30–32",
        hip: "34–35",
        thigh: "20–21",
        inseam: "8.625",
      },
      { size: "32", waist: "32–34", hip: "36–37", thigh: "22–23", inseam: "9" },
      {
        size: "34",
        waist: "34–36",
        hip: "38–39",
        thigh: "24–25",
        inseam: "9.375",
      },
      {
        size: "36",
        waist: "36–38",
        hip: "40–41",
        thigh: "26–27",
        inseam: "9.375",
      },
      {
        size: "38",
        waist: "38–40",
        hip: "42–43",
        thigh: "28–29",
        inseam: "9.375",
      },
    ],
    cm: [
      {
        size: "22",
        waist: "51–56",
        hip: "59–61",
        thigh: "33–36",
        inseam: "15",
      },
      {
        size: "24",
        waist: "59–64",
        hip: "64–69",
        thigh: "38–43",
        inseam: "16",
      },
      {
        size: "26",
        waist: "64–71",
        hip: "69–79",
        thigh: "41–43",
        inseam: "18",
      },
      {
        size: "28",
        waist: "71–76",
        hip: "81–84",
        thigh: "46–48",
        inseam: "20",
      },
      {
        size: "30",
        waist: "76–81",
        hip: "86–89",
        thigh: "51–54",
        inseam: "22",
      },
      {
        size: "32",
        waist: "81–86",
        hip: "92–94",
        thigh: "56–59",
        inseam: "23",
      },
      {
        size: "34",
        waist: "86–92",
        hip: "97–99",
        thigh: "61–64",
        inseam: "24",
      },
      {
        size: "36",
        waist: "92–97",
        hip: "102–104",
        thigh: "66–69",
        inseam: "24",
      },
      {
        size: "38",
        waist: "97–102",
        hip: "106–109",
        thigh: "71–74",
        inseam: "24",
      },
    ],
  },

  // Women's Sports Bras
  womenSportsBras: {
    in: [
      { size: "XS", bust: "32", underband: "26" },
      { size: "S", bust: "34", underband: "28" },
      { size: "M", bust: "36", underband: "30" },
      { size: "L", bust: "38", underband: "32" },
      { size: "XL", bust: "40", underband: "34" },
    ],
    cm: [
      { size: "XS", bust: "82", underband: "66" },
      { size: "S", bust: "87", underband: "71" },
      { size: "M", bust: "92", underband: "76" },
      { size: "L", bust: "97", underband: "81" },
      { size: "XL", bust: "102", underband: "86" },
    ],
  },

  // Women's Active Tops
  womenActiveTops: {
    in: [
      { size: "XS", bust: "32", waist: "25" },
      { size: "S", bust: "34", waist: "27" },
      { size: "M", bust: "36", waist: "29" },
      { size: "L", bust: "38", waist: "31" },
      { size: "XL", bust: "40", waist: "33" },
    ],
    cm: [
      { size: "XS", bust: "82", waist: "64" },
      { size: "S", bust: "87", waist: "69" },
      { size: "M", bust: "92", waist: "74" },
      { size: "L", bust: "97", waist: "79" },
      { size: "XL", bust: "102", waist: "84" },
    ],
  },

  // Women's Active Bottoms
  womenActiveBottoms: {
    in: [
      { size: "XS", waist: "25", hip: "35" },
      { size: "S", waist: "27", hip: "37" },
      { size: "M", waist: "29", hip: "39" },
      { size: "L", waist: "31", hip: "41.5" },
      { size: "XL", waist: "33", hip: "43" },
    ],
    cm: [
      { size: "XS", waist: "64", hip: "89" },
      { size: "S", waist: "69", hip: "94" },
      { size: "M", waist: "74", hip: "99" },
      { size: "L", waist: "79", hip: "106" },
      { size: "XL", waist: "84", hip: "109" },
    ],
  },

  // Slides
  slides: {
    in: [
      { size: "S", length: "6-7.5" },
      { size: "M", length: "8-9" },
      { size: "L", length: "9.5-10.5" },
    ],
    cm: [
      { size: "S", length: "15-19" },
      { size: "M", length: "20-23" },
      { size: "L", length: "24-27" },
    ],
  },
};

// Helper functions for rendering charts
window.JolynSizeChart = {
  // Get data for specific product type and unit
  getData: function (productType, unit = "in") {
    return window.JolynSizeChartData[productType]
      ? window.JolynSizeChartData[productType][unit]
      : [];
  },

  // Render a size chart table
  renderChart: function (
    containerId,
    productType,
    unit = "in",
    highlightColumn = null
  ) {
    const data = this.getData(productType, unit);
    const container = document.getElementById(containerId);

    if (!container || !data.length) return;

    // Get column headers from first data item
    const firstItem = data[0];
    let columns = Object.keys(firstItem);

    // For womenOnePiecesTraining, reorder columns to put category first
    if (productType === "womenOnePiecesTraining") {
      columns = columns.filter((col) => col !== "category");
      columns.unshift("category"); // Put category first
    } else {
      // For other charts, remove category column if it exists
      columns = columns.filter((col) => col !== "category");
    }

    let html = '<div class="chart-frame">';

    // Build data rows (no redundant key column)
    html += '<div class="values">';

    columns.forEach((col, colIndex) => {
      const isHighlighted = col === highlightColumn;
      const colClass = isHighlighted ? ' class="highlight-column"' : "";
      html += `<ul${colClass}>`;

      // Header for this column
      let unitSuffix = "";

      if (col === "dressSize") {
        // For dress size column, show US or UK instead of in/cm
        unitSuffix = ` (${unit === "in" ? "US" : "UK"})`;
      } else if (col !== "size" && col !== "cupSize" && col !== "category") {
        // For other measurement columns, show the unit (in/cm)
        unitSuffix = ` (${unit})`;
      }

      html += `<li>${this.formatColumnHeader(col)}${unitSuffix}</li>`;

      // Data for this column
      if (col === "category" && productType === "womenOnePiecesTraining") {
        // Special handling for category column with rowspan-like behavior
        // Count rows for each category
        const youthCount = data.filter(
          (item) => item.category === "YOUTH"
        ).length;
        const adultCount = data.filter(
          (item) => item.category === "ADULT"
        ).length;

        // Create exactly two cells: one for YOUTH, one for ADULT
        html += `<li class="category-span category-span-${youthCount}">YOUTH</li>`;
        html += `<li class="category-span category-span-${adultCount}">ADULT</li>`;
      } else {
        data.forEach((item) => {
          html += `<li>${item[col] || ""}</li>`;
        });
      }
      html += "</ul>";
    });

    html += "</div>";

    html += "</div>";
    container.innerHTML = html;
  },

  // Format column header for display
  formatColumnHeader: function (col) {
    const headerMap = {
      size: "Size",
      category: "&nbsp;", // Empty header for category column
      dressSize: "Dress Size",
      torso: "Torso",
      cupSize: "Cup Size",
      cup: "Cup",
      waist: "Waist",
      hip: "Hip",
      overBust: "Over Bust",
      bust: "Bust",
      underBust: "Under Bust",
      thigh: "Thigh",
      inseam: "Inseam",
      underband: "Underband",
      length: "Length",
    };
    return headerMap[col] || col;
  },

  // Switch between units
  switchUnit: function (newUnit) {
    // Store current unit preference
    localStorage.setItem("jolynSizeChartUnit", newUnit);

    // Update all visible charts
    document.querySelectorAll("[data-size-chart]").forEach((element) => {
      const productType = element.getAttribute("data-size-chart");
      const highlightColumn = element.getAttribute("data-highlight-column");
      this.renderChart(element.id, productType, newUnit, highlightColumn);
    });

    // Update unit toggle buttons
    document.querySelectorAll(".unit-toggle").forEach((btn) => {
      btn.classList.toggle("active", btn.getAttribute("data-unit") === newUnit);
    });
  },

  // Initialize size charts on page load
  init: function () {
    const savedUnit = localStorage.getItem("jolynSizeChartUnit") || "in";

    // Render all charts
    document.querySelectorAll("[data-size-chart]").forEach((element) => {
      const productType = element.getAttribute("data-size-chart");
      const highlightColumn = element.getAttribute("data-highlight-column");
      this.renderChart(element.id, productType, savedUnit, highlightColumn);
    });

    // Set up unit toggle
    document.querySelectorAll(".unit-toggle").forEach((btn) => {
      btn.classList.toggle(
        "active",
        btn.getAttribute("data-unit") === savedUnit
      );
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.switchUnit(btn.getAttribute("data-unit"));
      });
    });
  },
};

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  window.JolynSizeChart.init();
});
